<template>
  <div id="app" :class="{ 'is-mobile': isMobile }">
    <!-- 어드민 페이지가 아닐 때만 UI 표시 -->
    <template v-if="!isAdminPage">
      <!-- 웹 전용 -->
      <template v-if="!isMobile">
        <SplashScreen v-if="showSplash" @close="showSplash = false" />
        <CustomCursor />
        <MainHeader />
        <SideBanner />
        <FloatingBottomBar />
      </template>

      <!-- 모바일 전용 -->
      <template v-else>
        <MobileSplashScreen v-if="showMobileSplash" @close="showMobileSplash = false" />
        <MobileHeader />
        <!-- 홈에서만 표시 -->
        <template v-if="isMobileHome">
          <MobileFloatingButton />
          <MobileBottomPromo />
        </template>
        <MobileFloatingContact />
      </template>
    </template>

    <main class="main-content">
      <MobilePromoBar v-if="isMobileHome" />
      <router-view />
    </main>
  </div>
</template>

<script>
import MainHeader from '@/components/web/common/MainHeader.vue'
import SideBanner from '@/components/web/common/SideBanner.vue'
import CustomCursor from '@/components/web/common/CustomCursor.vue'
import FloatingBottomBar from '@/components/web/common/FloatingBottomBar.vue'
import SplashScreen from '@/components/web/common/SplashScreen.vue'
import MobileHeader from '@/components/mobile/common/MobileHeader.vue'
import MobilePromoBar from '@/components/mobile/common/MobilePromoBar.vue'
import MobileFloatingButton from '@/components/mobile/common/MobileFloatingButton.vue'
import MobileFloatingContact from '@/components/mobile/common/MobileFloatingContact.vue'
import MobileBottomPromo from '@/components/mobile/common/MobileBottomPromo.vue'
import MobileSplashScreen from '@/components/mobile/common/MobileSplashScreen.vue'

export default {
  name: 'App',
  components: {
    MainHeader,
    SideBanner,
    CustomCursor,
    FloatingBottomBar,
    SplashScreen,
    MobileHeader,
    MobilePromoBar,
    MobileFloatingButton,
    MobileFloatingContact,
    MobileBottomPromo,
    MobileSplashScreen
  },
  data() {
    return {
      showSplash: true,
      showMobileSplash: true,
      isMobile: false
    }
  },
  computed: {
    isMobileHome() {
      return this.isMobile && this.$route.path === '/'
    },
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap');

:root {
  /* 폰트 */
  --font-paperlogy: 'Paperlogy', sans-serif;
  --font-pretendard: 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-serif: 'Cormorant Garamond', serif;
  --font-luxury: 'Cinzel', serif;

  /* 컬러 */
  --rayone-primary: #112238;
  --rayone-primary-light: #1E3555;
  --rayone-primary-dark: #091525;
  --text-color: #2c3e50;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-pretendard);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

.main-content {
  /* padding-top 제거 - 풀스크린 섹션용 */
}
</style>
